/**
 * TELEFON → WhatsApp bağlantısı (kullanıcı, 2026-09-28: cari kartındaki
 * telefonun yanında WhatsApp simgesi, tıklayınca o numaraya mesaj).
 *
 * Kayıtlardaki numaralar yerel biçimde: "0533 834 79 06", "0392 223 35 00".
 * KKTC numaraları da Türkiye'nin +90 koduyla aranır (0533/0542/0548 cep,
 * 0392 sabit), yani "0 + 10 hane" → "90 + 10 hane".
 *
 * YALNIZCA CEP NUMARASINA simge çıkar (ülke kodundan sonra 5 ile başlayan):
 * sabit hatta (0392…, 444…) WhatsApp neredeyse hiç yok ve simge "bu numaraya
 * WhatsApp'tan yazılabilir" izlenimi verirdi. Yabancı numara (+44…, 00…) ise
 * olduğu gibi kabul edilir — hangisinin cep olduğunu bilemeyiz.
 */
export function whatsappNumarasi(tel) {
  const ham = String(tel || '').trim();
  if (!ham) return null;
  let rakam = ham.replace(/\D/g, '');
  let yabanci = false;
  if (ham.startsWith('+')) {
    yabanci = !rakam.startsWith('90');
  } else if (rakam.startsWith('00')) {
    rakam = rakam.slice(2);
    yabanci = !rakam.startsWith('90');
  } else if (rakam.length === 11 && rakam.startsWith('0')) {
    rakam = '90' + rakam.slice(1);
  } else if (rakam.length === 10) {
    rakam = '90' + rakam;
  } else if (!(rakam.length === 12 && rakam.startsWith('90'))) {
    return null;                       // "188", "444 73 78" gibi kısa/özel numaralar
  }
  if (yabanci) return rakam.length >= 8 ? rakam : null;
  return rakam.length === 12 && rakam[2] === '5' ? rakam : null;
}

export const whatsappAdresi = (tel) => {
  const n = whatsappNumarasi(tel);
  return n ? `https://wa.me/${n}` : null;
};
